import { FilterItem, TableData } from "../component/appeal-process/interface/InterFace";

//Filter Box Data
export const appealStatuses: FilterItem = {
  selectorLabel: "Appeal Statuses",
  filtterData: [
    { inputValue: "in_process", inputOption: "Appeal in Process" },
    { inputValue: "accepted", inputOption: "Appeal Accepted" },
    { inputValue: "rejected", inputOption: "Appeal Rejected" },
  ],
};
export const offenceTypes: FilterItem = {
  selectorLabel: "Offence Types",
  filtterData: [
    { inputValue: "Over Speeding", inputOption: "Over Speeding" },
    { inputValue: "Moving contraventions", inputOption: "Moving contraventions" },
    { inputValue: "Wrong way", inputOption: "Wrong way" },
    { inputValue: "Static contraventions", inputOption: "Static contraventions" },
    { inputValue: "Bus lane contraventions", inputOption: "Bus lane contraventions" },
  ],
};
export const offenceCodes: FilterItem = {
  selectorLabel: "Offence Codes",
  filtterData: [
    { inputValue: "Parked in a restricted street during prescribed hours", inputOption: "Parked in a restricted street" },
    { inputValue: "Parked in a meter bay when penalty time is indicated", inputOption: "Parked in a meter bay when" },
    { inputValue: "Parked after the expiry of paid for time", inputOption: "Parked after the expiry of paid for time" },
    { inputValue: "Parked without clearly displaying ", inputOption: "Parked without clearly displaying a valid pay & display ticket or voucher" },
    { inputValue: "Parked with payment made to extend", inputOption: "Parked with payment made to extend the stay beyond initial time" },
  ],
};
export const appealTypes: FilterItem = {
  selectorLabel: "Appeal Type",
  filtterData: [
    { inputValue: "formal", inputOption: "formal" },
    { inputValue: "informal", inputOption: "informal" },
    { inputValue: "independent", inputOption: "independent" },
  ],
};
export const timeFrames: FilterItem = {
  selectorLabel: "Time Frame",
  filtterData: [
    { inputValue: "Today", inputOption: "Today" },
    { inputValue: "Last Week", inputOption: "Last Week" },
    { inputValue: "This month", inputOption: "This month" },
    { inputValue: "Last Month", inputOption: "Last month" },
    { inputValue: "Year To Date", inputOption: "Year to date" },
    { inputValue: "Last Year", inputOption: "Last Year" },
    { inputValue: "Date Range", inputOption: "Date range" },
  ],
};

//Table Data
export const tableData: TableData[] = [
  {
    no: 1,
    appealNumber: "D87H792S1",
    appealDate: "20/09/2022",
    offenceCode: "AHU6679CX",
    pcnIssuedDate: "20/09/2022",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 2,
    appealNumber: "S87H792S1",
    appealDate: "16/09/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "04/08/2022",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 3,
    appealNumber: "TS7H792S1",
    appealDate: "04/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 4,
    appealNumber: "UX7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 5,
    appealNumber: "PK7H792S1",
    appealDate: "04/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 6,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 7,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 8,
    appealNumber: "PK7H792S1",
    appealDate: "04/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 9,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 10,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 11,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 12,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 13,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 14,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 15,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static Contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 16,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 17,
    appealNumber: "D87H792S1",
    appealDate: "09/02/2021",
    offenceCode: "BHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 18,
    appealNumber: "S87H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "04/08/2022",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 19,
    appealNumber: "TS7H792S1",
    appealDate: "04/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 20,
    appealNumber: "UX7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 21,
    appealNumber: "PK7H792S1",
    appealDate: "04/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 22,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 23,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 24,
    appealNumber: "PK7H792S1",
    appealDate: "09/08/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 26,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 27,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 28,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 29,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 30,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 31,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 32,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static Contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 33,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 34,
    appealNumber: "D87H792S1",
    appealDate: "09/02/2021",
    offenceCode: "CHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 35,
    appealNumber: "S87H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "04/08/2022",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 36,
    appealNumber: "TS7H792S1",
    appealDate: "07/07/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 36,
    appealNumber: "UX7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 37,
    appealNumber: "PK7H792S1",
    appealDate: "03/03/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Wrong way",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 38,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 39,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 40,
    appealNumber: "PK7H792S1",
    appealDate: "01/01/2022",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
  {
    no: 41,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "03/08/2022",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 42,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 43,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 44,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 45,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Moving contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 46,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static contraventions",
    vehicleNumber: "UT55FTR",
    action: `In Process`,
    status: "In Process",
    appealType: "formal",
  },
  {
    no: 47,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Static Contraventions",
    vehicleNumber: "UT55FTR",
    action: `Accepted`,
    status: "Accepted",
    appealType: "formal",
  },
  {
    no: 48,
    appealNumber: "PK7H792S1",
    appealDate: "09/02/2021",
    offenceCode: "JHU6679CX",
    pcnIssuedDate: "12/04/2020",
    offenceType: "Over Speeding",
    vehicleNumber: "UT55FTR",
    action: `Rejected`,
    status: "Rejected",
    appealType: "formal",
  },
];

//Form Data
export const groundReasonChallengeList = [
  { challengeType: "I was not the owner of the vehicle at the time of the alleged contravention" },
  { challengeType: "The  alleged contravention does not occour" },
  { challengeType: "The PCN increase the amount in these circumstances of the case  " },
  { challengeType: "The relevant designation order was invalid " },
  { challengeType: "There has been a procedural on behalf of the authority " },
  { challengeType: "Others" },
];
export const appealStatus = [{ status: "ACCEPTED" }, { status: "REJECTED" }, { status: "IN PROGRESS" }];

export const pcnList = [{ pcnNumbers: "BD76543218" }, { pcnNumbers: "CG78906543" }, { pcnNumbers: "LR76543218" }, { pcnNumbers: "NG78906543" }];

export const formOffenceTypes = [{ offenceType: "Over Speeding" }, { offenceType: "Moving contraventions" }, { offenceType: "Wrong way" }, { offenceType: "Static contraventions" }];

//Pdf table header
export const pdfTableHeading = [
  {
    no: "No",
    appealType: "Appeal Type",
    // appealNumber: "Appeal Number",
    appealDate:"Appeal Date",
    pcnIssuedDate: "PCN Issued Date",
    offenceCode: "Offence Code",
    pcnNumber: "PCN Number",
    offenceType: "Offence Type",
    status: "Status",
  },
];
